import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { formatNumber } from 'utils/formats';

import { HistoryMovement } from 'types';

import movementTypes from 'modules/transactions/constants/movementTypes';
import { RowCell } from 'modules/_shared/Table/types/RowCell';
import TableRow from 'modules/_shared/Table/components/TableRow';

type RenumerationTableRowProps = {
  index: number;
  movement: HistoryMovement;
};

const RenumerationTableRow: FC<RenumerationTableRowProps> = ({
  index,
  movement,
}) => {
  const { t } = useTranslate();

  const isEntireClassRenumeration =
    movement.movementType === movementTypes.ENTIRE_CLASS_RENUMERATION;

  const isAutomaticRenumeration =
    movement.movementType === movementTypes.AUTOMATIC_RENUMERATION;

  const classCell = {
    key: `movement-class-${index}`,
    content: movement.holdingClassName,
    textPosition: 'left',
  };

  const actionCell = {
    key: `movement-action-${index}`,
    content: '',
    textPosition: 'right',
  };

  const resultCell = {
    key: `movement-result-${index}`,
    content: t('RenumberedSequentially'),
    textPosition: 'left',
  };

  const automaticCells = [
    {
      key: `movement-scope-${index}`,
      content: t('WholeCompany'),
      textPosition: 'left',
    },

    resultCell,
    actionCell,
  ];

  const entireClassCells = [
    {
      key: `movement-scope-${index}`,
      content: t('AllRanges'),
      textPosition: 'left',
    },

    resultCell,
    classCell,
    actionCell,
  ];

  const defaultCells = [
    {
      key: `movement-from-${index}`,
      content: formatNumber(movement.from),
      textPosition: 'right',
    },

    {
      key: `movement-to-${index}`,
      content: formatNumber(movement.to),
      textPosition: 'right',
    },

    {
      key: `movement-newForm-${index}`,
      content: formatNumber(movement.newFrom),
      textPosition: 'right',
    },

    {
      key: `movement-newTo-${index}`,
      content: formatNumber(movement.newTo),
      textPosition: 'right',
    },

    classCell,
    actionCell,
  ];

  const getCells = () => {
    if (isAutomaticRenumeration) return automaticCells;
    if (isEntireClassRenumeration) return entireClassCells;
    return defaultCells;
  };

  const cells = getCells().filter(Boolean) as RowCell[];

  return <TableRow cells={cells} />;
};

export default RenumerationTableRow;
